// Helpers for routing photos through the server-side image optimizer (/img)
// which resizes + converts to WebP with long-lived caching.

const PROXYABLE_REMOTE_HOSTS = [
  "timberandlove.com",
  "www.timberandlove.com",
  "images.unsplash.com",
  "storage.googleapis.com",
];

export function isOptimizable(src: string | undefined | null): boolean {
  if (!src) return false;
  if (src.startsWith("data:") || src.startsWith("blob:")) return false;
  if (src.startsWith("/")) return true;
  try {
    const url = new URL(src);
    return PROXYABLE_REMOTE_HOSTS.includes(url.hostname);
  } catch {
    return false;
  }
}

export function optimizedUrl(src: string, width: number, quality = 90): string {
  if (!isOptimizable(src)) return src;
  return `/img?src=${encodeURIComponent(src)}&w=${width}&q=${quality}`;
}

export function optimizedSrcSet(
  src: string,
  widths: number[] = [480, 768, 1200, 1600],
  quality = 90,
): string | undefined {
  if (!isOptimizable(src)) return undefined;
  return widths.map((w) => `${optimizedUrl(src, w, quality)} ${w}w`).join(", ");
}
